import React from 'react';
import Info from 'components/shared/Info';
import clsx from 'clsx';
import styles from './Field.module.scss';
import { useTranslation } from 'react-i18next';

function Field({
  title,
  isOptional,
  info,
  infoSmall,
  infoRight,
  children,
}: {
  title: string | React.ReactNode;
  isOptional?: boolean;
  info?: React.ReactNode;
  infoRight?: React.ReactNode;
  infoSmall?: boolean;
  children?: React.ReactNode;
}) {
  const { t } = useTranslation() as any;
  return (
    <div className={styles.field}>
      {title ? (
        <div className={styles.titleRow}>
          <div className={styles.title}>{t(title)}</div>
          {isOptional ? <div className={styles.isOptional}>{t('Optional')}</div> : null}
        </div>
      ) : null}

      {children}
      {info || infoRight ? (
        <div className={styles.infoRow}>
          {info ? (
            <Info style={{ maxWidth: '70%' }} small={infoSmall}>
              {info}
            </Info>
          ) : null}
          {infoRight ? (
            <span className={clsx(styles.infoRight, infoSmall && styles.infoRightSmall)}>
              {infoRight}
            </span>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
export default Field;
